import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

import moment from 'moment'
import i18n from '@/plugins/i18n'

const PageConst= {
  ACTION: {
    doBrowse: { api: 'T3110LessonReportService.C50101_doBrowse_AtDataTable', input: {}},
  },
}

const module = {
  state: {
    PageConst,
    defaultDoBrowse: {
      searchInfo: {
        search: '',
        start_date: moment().startOf('day').subtract(6, 'day').format('YYYY-MM-DD'),
        end_date: moment().startOf('day').format('YYYY-MM-DD'),
      },
      orderBy: {},
      doBrowseStatus: 'init',
      errorMessage: {},
    },
    errorMessage: {},
    dropdownData:{
      advisors:[]
    }
  },

  getters: {
    reportStatusButton: (state) => (reportStatus) => {
      const isAdmin = window.vue.$store.getters['Auth/isAdmin'];
      const defaultData = {
        props:{
          style: {
            color: 'white',
          },
          size: 'small',
          width: 100,
        }
      }
      switch (reportStatus) {
        case 0:
          return {
            props: defaultData.props,
            text: window.vue.$i18n.t('C50101.C50101Store.wj5nh98oipnaIxusOgjUg'),
            color: '#82d973',
            disabled: false,
            C50102Mode: isAdmin ? 'view' : 'add',
          }
        case 1:
          return {
            props: defaultData.props,
            text: window.vue.$i18n.t('C50101.C50101Store.cDMCFRgGj-ykOgG21wnd4'),
            color: '#2196f3',
            disabled: false,
            C50102Mode: isAdmin ? 'review' : 'view',
          }
        case 2:
          return {
            props: defaultData.props,
            text: window.vue.$i18n.t('C50101.C50101Store.K-T8zqcYGWg44j_wU3pHr'),
            color: '#cc3300',
            disabled: false,
            C50102Mode: isAdmin ? 'review' : 'amend',
          }
        case 3:
          return {
            props: defaultData.props,
            text: window.vue.$i18n.t('C50101.C50101Store.grYyP_-dafupGE7m08ZAT'),
            color: '#7030A0',
            disabled: false,
            C50102Mode: isAdmin ? 'review' : 'view',
          }
        case 8:
          return {
            props: defaultData.props,
            text: window.vue.$i18n.t('C20301.C20301Table.qian-xi'),
            color: '#215F9A',
            disabled: !isAdmin,
            // C50102Mode: isAdmin ? 'review' : 'noUse',
            C50102Mode: isAdmin ? 'review' : 'view',
          }
        case 4:
          return {
            props: defaultData.props,
            text: window.vue.$i18n.t('C50101.C50101Store.FzRVFdJdQN0TKSE5862v9'),
            color: '#0000FF',
            disabled: !isAdmin,
            // C50102Mode: isAdmin ? 'afterReview' : 'noUse(wontShow)',
            C50102Mode: isAdmin ? 'afterReview' : 'view',
          }
        case 9:
          return {
            props: defaultData.props,
            text: window.vue.$i18n.t('C50101.C50101Store.CH3L_1d47oaFwxSW3i6P0'),
            color: '#000000',
            disabled: true,
            // C50102Mode: isAdmin ? 'noUse' : 'noUse(wontShow)',
            C50102Mode: isAdmin ? 'view' : 'view',
          }
        default:
          return {
            props: defaultData.props,
            text: window.vue.$i18n.t('C50101.C50101Store.0GrwPMbDTn7hLnSCmWmC4'),
            color: '#b0c4de',
            disabled: isAdmin,
            // C50102Mode: isAdmin ? 'noUse' : 'add',
            C50102Mode: isAdmin ? 'view' : 'add',
          }
      }
    },
  },

  mutations: {},

  actions: {
    init ({ commit, state }, payload) {
      $this.$api.postData({
        data: {
          dropdownData: {
            api: 'T3110LessonReportService.C50101_getDropdownData',
            input: payload,
          }
        }
      }).then((res) => {
        commit('setState', {
          dropdownData: res.dropdownData.output
        })
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
